import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../config";
import Navbar from '../../components/Navbar/Navbar';

export default function ArConcluido() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');

    const statusMap = {
        1: 'Despacho Notificação',
        2: 'Relatório',
        3: 'Análise Técnica',
        4: 'Solicitado Documentação',
        5: 'Análise Documental',
        6: 'Análise Encerramento',
        7: 'Deferido',
        8: 'Indeferido',
        9: 'Arquivado',
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/ar/concluidos`);
                if (!response.ok) {
                    throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
                }
                const result = await response.json();

                result.sort((a, b) => {
                    const dateA = parseDate(a.dataMovimentacao);
                    const dateB = parseDate(b.dataMovimentacao);
                    if (dateA.getTime() !== dateB.getTime()) {
                        return dateA - dateB;
                    }
                    return a.processo.localeCompare(b.processo, 'en', { numeric: true });
                });

                setData(result);
            } catch (error) {
                console.error('Erro ao buscar dados:', error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const parseDate = (dateString) => {
        if (!dateString) return new Date();
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day);
    };

    const filteredData = data.filter(item => {
        return item.processo ? item.processo.toString().includes(searchTerm) : false;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const nextPage = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };
    const prevPage = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };

    const downloadPDF = async (pdfFilePath) => {
        const fullUrl = `${API_BASE_URL}/download/${pdfFilePath}`;
        try {
            const response = await fetch(fullUrl, {
                method: 'GET',
                headers: { 'Content-Type': 'application/pdf' }
            });
            if (!response.ok) throw new Error('Erro ao buscar o PDF');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = pdfFilePath;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erro ao baixar o PDF:", error);
        }
    };

    const getStatusBorderClass = (status) => {
        const statusText = statusMap[status];
        switch (statusText) {
            case 'Despacho Notificação': return 'borda-verde-escuro';
            case 'Relatório': return 'borda-verde-claro';
            case 'Análise Técnica': return 'borda-azul-claro';
            case 'Análise Documental': return 'borda-azul-escuro';
            case 'Análise Encerramento': return 'borda-roxo';
            case 'Solicitado Documentação': return 'borda-vermelho';
            case 'Deferido':
            case 'Indeferido':
            case 'Arquivado':
            default: return '';
        }
    };

    return (
        <div className="home">
            <Navbar searchTerm={searchTerm} onSearchChange={setSearchTerm} />
            <div className="table-container">
                {loading ? (
                    <p>Carregando...</p>
                ) : (
                    <>
                        <table className="data-table">
                            <thead>
                            <tr>
                                <th>Ordem</th>
                                <th>Processo</th>
                                <th>Data da Movimentação</th>
                                <th>Status</th>
                                <th>PDF</th>
                            </tr>
                            </thead>
                            <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((item, index) => (
                                    <tr key={item.id_ac_atendimento}>
                                        <td data-label="Ordem">{indexOfFirstItem + index + 1}</td>
                                        <td data-label="Processo">{item.processo}</td>
                                        <td data-label="Data da Movimentação">{item.dataMovimentacao}</td>
                                        <td data-label="Status">
                                            <div className={getStatusBorderClass(item.status)}>
                                                {statusMap[item.status] || 'Status desconhecido'}
                                            </div>
                                        </td>
                                        <td>
                                            <button
                                                className="download-button"
                                                disabled={!item.pdfFilePath}
                                                onClick={() => downloadPDF(item.pdfFilePath)}
                                            >
                                                Baixar PDF
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7">Nenhum credenciamento encontrado!</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button onClick={prevPage} className="page-button" disabled={currentPage === 1}>
                                Anterior
                            </button>
                            {Array.from({ length: totalPages }, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => paginate(i + 1)}
                                    className={`page-button ${currentPage === i + 1 ? 'active' : ''}`}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button onClick={nextPage} className="page-button" disabled={currentPage === totalPages}>
                                Próxima
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
